import { render, staticRenderFns } from "./AdditionalItems.vue?vue&type=template&id=afa66ca4&scoped=true"
import script from "./AdditionalItems.vue?vue&type=script&lang=js"
export * from "./AdditionalItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa66ca4",
  null
  
)

export default component.exports